export default __webpack_public_path__ + "static/tag-do-4-dark-9956b8d64f16b104bcb72cf5ac80ebd4.png";